import { requestPost } from '../services/real.backend';

export function sendFirebaseToken(token) {
  return requestPost('/api/users/firebase', { token })
    .then((resp) => resp)
    .catch((error) => {
      console.log('Error: ', error);
    });
}
